import jwtDecode, { JwtPayload } from 'jwt-decode';

export const SUPPORT_REDIRECT_URL = 'https://www.bandwidth.com/support';
export const SUPPORT_ROLE = 'supportAccess';
export const TEST_ROLE = 'testRole';

interface PassportAccessTokenClaims extends JwtPayload {
  roles?: string[];
}

/**
 * Checks the user's access token claims for role-based redirect logic.
 * If the user has supportRole but NOT testRole, they should be redirected
 * to the support page instead of the dashboard.
 */
const getSupportRedirectUrl = (accessToken?: string): string | null => {
  if (!accessToken) {
    return null;
  }

  try {
    const claims = jwtDecode<PassportAccessTokenClaims>(accessToken);
    const hasSupportRole = claims.roles?.includes(SUPPORT_ROLE) ?? false;
    const hasTestRole = claims.roles?.includes(TEST_ROLE) ?? false;

    if (hasSupportRole && !hasTestRole) {
      return SUPPORT_REDIRECT_URL;
    }

    return null;
  } catch {
    return null;
  }
};

export default getSupportRedirectUrl;
